import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';


import JsonView from 'react-json-view';
import Divider from '@mui/material/Divider';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import IconMore from '@mui/icons-material/MoreHoriz';
import IconSave from '@mui/icons-material/Save';
import IconCancel from '@mui/icons-material/Cancel';
import IconClose from '@mui/icons-material/Close';
import { ClosableBar } from '../dialogs';


const s:any = {
  dialogcontent: {
    backgroundColor: 'white'
  },
  root: {
    flex: '1 1 auto',
    background: 'background.paper',
  },
  jsonbox: {

  },
};
// const styles = (theme:Theme) => {
//   const cfg:any = {
//     root: {
//       //width: '100%',
//       flex: '1 1 auto',
//       background: 'background.paper',
//     },
//     master: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       borderBottomColor: 'grey[500]',
//       borderBottomWidth: 1,
//       borderBottomType: 'solid',
//     },
//     textField: {
//       marginLeft: 'spacing(1)',
//       marginRight: 'spacing(1)',
//       //width: 200,
//     },
//     
//       display:'none',
//     },
//   };
// return cfg;
// }

class FJsonField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      id: this.props.id,
      value: this.props.value || {"name":"Adenta Barrier","district":"Adenta","region":"Greater Accra","records":[1,5,6,7,13,27]},
      open: false,
    };
  }

  onOpen = (event:any) => {
    console.log('called open',event.currentTarget);
    this.setState({open:true});
  }

  onClose = (event:any) => {
    console.log('called close',event.currentTarget);
    this.setState({open:false});
  }

  onMouseDown = (event:any) => {
    console.log('called onMouseDown',event.currentTarget);
    event.preventDefault();
  }

  onAdd = () => {
  };

  onEdit = () => {
  };

  onDelete = () => {
  };

  onView = () => {
  };

  onSave = () => {

  };

  count = (rec:any) => {
    const to = typeof rec;
    const cn = (rec === undefined || rec === null)?0:
               (Array.isArray(rec))?rec.length:
               (to === 'boolean' || to === 'number' || to === 'string')?1:
               (to === 'object')?Object.keys(rec).length: 0;
    return cn;
  }

  formatValue = (label:string,value:any) => {
    const cn = this.count(value);
    const rtn = `${label}: {...} ${cn} items`;
    return rtn;
  }

  render() {
    //const {id,label,divider,classes } = this.props;
    const {open,value} = this.state;
    const {mode,id,label,required=false,classes,options={}} = this.props;
    const title = `${label} Dataset`;

    return (
      <Box sx={{...s.master222}}>
      <Fragment>
      <TextField
        label={label}
        name={id}
        type={'text'}
        fullWidth={true}
        sx={{...s.textField}}
        margin='normal'
        helperText={'Click on right to update dataset'}
        //value={<Box><JsonView src={value} name={label} collapsed={true}/></Box>}
        value={this.formatValue(label,value)}
        variant={"standard"}
        required={required}
        InputProps={{
          endAdornment: 
            <InputAdornment position={"end"}>
              <IconButton
                onClick={this.onOpen}
                onMouseDown={this.onMouseDown}
              >
                <IconMore />
              </IconButton>
            </InputAdornment>
        }}
        {...options}
      />
        <Dialog open={open}  sx={{...s.dialog}} classes={{paper: classes.dialogcontent}} maxWidth={'md'}>
          <DialogTitle sx={{...s.titlebar}}>
            <ClosableBar onClose={this.onClose}>{title}</ClosableBar>
          </DialogTitle>
          <DialogContent sx={{...s.dialogcontent}}>
            <Box sx={{...s.jsonbox}}>
              <JsonView
                src={value}
                //id={id}
                //theme={'monokai'}
                name={false}
                iconStyle={'triangle'}
                indentWidth={2}
                collapsed={true}
                collapseStringsAfterLength={15}
                quotesOnKeys={false}
                onAdd={(mode!=='view')?this.onAdd:false}
                onEdit={(mode!=='view')?this.onEdit:false}
                onDelete={(mode!=='view')?this.onDelete:false}
                //onChange={this.handleChange}
              />
              
              
            </Box>

          </DialogContent>
          <DialogActions>
            <IconButton onClick={this.onClose} onMouseDown={this.onMouseDown}><IconCancel /></IconButton>
            <IconButton onClick={this.onClose} onMouseDown={this.onMouseDown}><IconSave /></IconButton>
            <IconButton onClick={this.onClose} onMouseDown={this.onMouseDown}><IconClose /></IconButton>
          </DialogActions>
        </Dialog>
      </Fragment>  

          

        {<Divider/>}
      </Box>
    );
  }
}

FJsonField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FJsonField;
